import React, { useEffect, useState } from 'react';
import {
  createAdminBatch,
  editAdminBatch,
  showAdminBatch,
} from '../../../service/admin/adminBatch.service';
import { SubmitHandler, useForm } from 'react-hook-form';
import { adminExamAlertsTypes, BatchTypes } from '../../../types/AdminTypes';
import { statusList, toBoolean } from '../../../helpers/helpers';
import { setContentUpdate } from '../../../redux/contentUpdateSlice';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import Input from '../../../components/form/Input';
import formValidationRules from '../../../helpers/formvalidationRules';
import RadioButton from '../../../components/form/RadioButton';
import FormButton from '../../../components/button/FormButton';
import {
  createAdminExamAlert,
  editAdminExamAlert,
  showAdminExamAlert,
} from '../../../service/admin/adminExamAlert.service';
import WordUpload from '../../../components/uploads/WordUpload';
export default function AdminExamAlertCE(props: {
  type: string;
  data?: any;
  open: any;
}) {
  const [pageLoad, setPageLoad] = useState(false);
  const [fetchData, setFetchData] = useState<any>();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pageContent, setPageContent] = useState({
    button: 'Create Exam',
  });

  const dispatch = useDispatch();

  const fetchBatchDetail = async (id: string) => {
    const get: any = await showAdminExamAlert(id);
    if (get?.status === 'success') {
      setFetchData(get.message);
    }
  };
  useEffect(() => {
    setPageLoad(true);
    if (props.type === 'edit') {
      fetchBatchDetail(props.data.id);
      setPageContent({
        button: 'Update Exam',
      });
    }
    // fetchInstituteCenter()
    setPageLoad(false);
  }, []);

  const { handleSubmit, control } = useForm<adminExamAlertsTypes>({
    values: {
      name: fetchData?.name,
      examDate: fetchData?.exam_date.split('T00:00:00.000Z')[0],
      status: `${fetchData?.status ? fetchData?.status : true}`,
    },
  });
  const onSubmit: SubmitHandler<adminExamAlertsTypes> = async (
    data: adminExamAlertsTypes
  ) => {
    setLoading(true);
    let status_: any = toBoolean(data.status);
    let fetch: any;
    data.status = status_;
    if (props.type === 'create') {
      fetch = await createAdminExamAlert(data);
    }
    if (props.type === 'edit') {
      fetch = await editAdminExamAlert(fetchData?.id, data);
    }
    if (fetch?.status === 'success') {
      setLoading(false);
      dispatch(
        setContentUpdate({
          id: Math.random() * (100000 - 111111),
        })
      );
      props.open(false);
      return toast.success(fetch.message);
    }
    setLoading(false);
  };

  return (
    <>
      <div className="my-2">
        <form onSubmit={handleSubmit(onSubmit)} className="mb-5">
          <Input
            name="name"
            control={control}
            rules={{
              ...formValidationRules.required(),
              ...formValidationRules.minLength(3),
            }}
            label="Name"
            placeholder="Name"
          />
          <Input
            name="examDate"
            type="date"
            control={control}
            rules={{
              ...formValidationRules.required(),
              ...formValidationRules.minLength(3),
            }}
            label="Exam Date"
            placeholder="Name"
          />
          <RadioButton
            name="status"
            control={control}
            rules={{ ...formValidationRules.required() }}
            options={statusList}
            label="status"
          />
          <br />
          <FormButton loading={loading} title={pageContent.button} />
        </form>
      </div>
    </>
  );
}
